function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useState, useEffect } from 'react';
import { Chart, registerables } from 'chart.js';
import { Line } from 'react-chartjs-2';
import PropTypes from 'prop-types';
import { formatShortPrice } from '@domain-group/fe-allhomes-library';
import { lineGraphHeight } from '../../allhomes-listing-suburb-stats.style';
import { isClientSide } from '../client-side';
import * as styles from './line-graph.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var axisFont = {
  family: "'Source Sans Pro', Helvetica, Arial, sans-serif",
  size: 14
};

// Required by ChartJS to avoid crashing
if (isClientSide && registerables) {
  Chart.register(...registerables);
}
var average = values => values.reduce((acc, each) => acc + each, 0) / values.length;
var LineGraph = _ref => {
  var data = _ref.data,
    coloursProp = _ref.colours,
    height = _ref.height,
    options = _ref.options,
    className = _ref.className;
  var _useState = useState({
      show: false
    }),
    _useState2 = _slicedToArray(_useState, 2),
    tooltip = _useState2[0],
    setTooltip = _useState2[1];

  // Colours need to be resolved only during client-side render.
  var _useState3 = useState({
      resolved: false
    }),
    _useState4 = _slicedToArray(_useState3, 2),
    colours = _useState4[0],
    setColours = _useState4[1];
  useEffect(() => {
    if (!colours.resolved) {
      setColours(_objectSpread({
        resolved: true
      }, styles.colours()));
    }
  }, [colours.resolved]);
  var formatData = () => ({
    labels: data.labels,
    datasets: data.datasets.map((item, index) => ({
      borderColor: coloursProp[index],
      data: item.data,
      label: item.label
    }))
  });
  var renderTooltip = _ref2 => {
    var _tooltip$pos, _tooltip$pos2;
    var dataPoints = _ref2.tooltip.dataPoints;
    return ___EmotionJSX("div", {
      css: styles.tooltip({
        top: (_tooltip$pos = tooltip.pos) === null || _tooltip$pos === void 0 ? void 0 : _tooltip$pos.y,
        left: (_tooltip$pos2 = tooltip.pos) === null || _tooltip$pos2 === void 0 ? void 0 : _tooltip$pos2.x
      })
    }, ___EmotionJSX("div", {
      css: styles.tooltipHeading
    }, dataPoints[0].label), dataPoints.map(dataPoint => ___EmotionJSX("div", {
      css: styles.dataItem
    }, ___EmotionJSX("div", {
      css: styles.dataItemLabel
    }, ___EmotionJSX("div", {
      css: styles.roundel({
        colour: dataPoint.dataset.borderColor
      })
    }), ___EmotionJSX("div", null, dataPoint.dataset.label)), ___EmotionJSX("div", {
      css: styles.dataItemValue
    }, "$", dataPoint.formattedValue))));
  };
  var tooltipHandler = ctx => {
    var _ctx$tooltip;
    var show = (ctx === null || ctx === void 0 ? void 0 : (_ctx$tooltip = ctx.tooltip) === null || _ctx$tooltip === void 0 ? void 0 : _ctx$tooltip.opacity) !== 0;
    var dataPoints = ctx.tooltip.dataPoints,
      _ctx$chart$chartArea = ctx.chart.chartArea,
      left = _ctx$chart$chartArea.left,
      width = _ctx$chart$chartArea.width;
    var year = dataPoints[0].label;
    if (tooltip.show && !show) {
      setTooltip({
        show: false
      });
    } else if (
    // showing a hidden tooltip
    !tooltip.show && show ||
    // moving to a new data point
    tooltip.show && show && year !== tooltip.year) {
      var xCoord = dataPoints[0].element.x + 16; // includes 16px left margin
      var yCoord = average(dataPoints.map(_ref3 => {
        var yCoordinate = _ref3.element.y;
        return yCoordinate;
      }));

      // Check that the left side of the tooltip is closer to the left side of the graph.
      // If not, flip over to the other side of the data point.
      var intendedXCoord =
      // includes 16px right margin and negation of 16px left margin (hence, 32)
      xCoord < left + width / 2 ? xCoord : xCoord - 32 - styles.tooltipWidth;
      setTooltip({
        show: true,
        year,
        ctx,
        pos: {
          // Keep the tooltip from extending offscreen
          x: Math.max(Math.min(intendedXCoord,
          // Last offsets are 24px right margin of graph, reduced by 8px
          left + width - styles.tooltipWidth + 24 - 8),
          // 24px left margin of graph, reduced by 8px
          -24 + 8),
          y: yCoord
        }
      });
    }
  };
  var chartOptions = _ref4 => {
    var disableAnimation = _ref4.disableAnimation;
    return {
      responsive: true,
      maintainAspectRatio: false,
      animation: {
        duration: disableAnimation ? 0 : undefined
      },
      interaction: {
        intersect: false,
        axis: 'x',
        mode: 'nearest'
      },
      plugins: {
        legend: {
          display: false
        },
        tooltip: {
          enabled: false,
          external: tooltipHandler
        }
      },
      elements: {
        line: {
          borderWidth: 3
        },
        point: {
          radius: 5,
          borderWidth: 2,
          backgroundColor: colours.pointBackgroundColour,
          hoverRadius: 8,
          hoverBorderWidth: 4,
          hitRadius: 16
        }
      },
      scales: {
        x: {
          grid: {
            display: false,
            borderColor: colours.xScaleGridColour,
            borderWidth: 1
          },
          ticks: {
            font: axisFont,
            color: colours.axisColour
          }
        },
        y: {
          grid: {
            drawBorder: false
          },
          ticks: {
            callback: value => {
              var price = formatShortPrice(value);
              return "".concat(price.price).concat(price.unit);
            },
            font: axisFont,
            color: colours.axisColour
          }
        }
      },
      animations: {
        colors: false
      }
    };
  };
  return ___EmotionJSX("div", {
    css: styles.lineGraph({
      height
    }),
    className: className
  }, isClientSide && colours.resolved && ___EmotionJSX(Line, {
    data: formatData(),
    options: chartOptions(options)
  }), tooltip.show && renderTooltip(tooltip.ctx));
};
LineGraph.propTypes = {
  data: PropTypes.shape({
    labels: PropTypes.arrayOf(PropTypes.string),
    datasets: PropTypes.arrayOf(PropTypes.shape({
      label: PropTypes.string,
      data: PropTypes.arrayOf(PropTypes.number)
    }))
  }),
  colours: PropTypes.arrayOf(PropTypes.string),
  height: PropTypes.number,
  options: PropTypes.shape({
    disableAnimation: PropTypes.bool
  }),
  className: PropTypes.string
};
LineGraph.defaultProps = {
  data: {
    labels: [],
    datasets: []
  },
  colours: [],
  height: lineGraphHeight,
  options: {},
  className: ''
};
export default LineGraph;